<div (click)="toggleFilter()" role="button" class="animate__animated animate__bounceInDown drop-shadow-1">
    <div class="padding-1sm clip3" [ngClass]="bgClass()">
        <div class="d-flex gap-3 align-items-center clip3 justify-content-between primary-bg ps-3 w-fit">
            <div class="row">
                <span class="primary-text font-4 fw-normal" id="user-filter-status-label">
                    @switch(type())
                    {
                        @case(CatalogFilterType.Active)
                        {
                            Active               
                        }
                        
                        @case(CatalogFilterType.Archived)
                        {
                            Archived
                        }                     
                    }
                </span>
                <span class="font-6 fw-semibold" id='user-filter-status-count'>                                        
                    @if (count(); as userCount)
                    {
                        {{(userCount | number:'2.0-0')}}
                    }
                    @else { 0 }
                </span>
            </div>

            <div class="clip3 py-1" [ngClass]="bgClass()" id="macd-filter-status-indicator">
                <span class="material-icons-outlined font-9 text-white-900 height-45 width-80 d-flex align-items-center justify-content-center">{{ indicator() }}</span>
            </div>   
        </div>
    </div>
</div>
